import { FETCH_JOB_DETAILS } from '../actions/types'

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_JOB_DETAILS:
      state = action.payload.data.jobs
      return state
  }
  return state
}
